module.exports = __webpack_public_path__ + "img/download.ce2002cf.svg";